export default "__VITE_ASSET__yKfWgii9__"